import { useTranslation } from 'react-i18next'
import { useCanGoBack, useRouter } from '@tanstack/react-router'
import { ChevronLeftIcon } from 'lucide-react'
import { Button } from 'ui/button'

export const PrivacyPolicy = () => {
  const router = useRouter()
  const canGoBack = useCanGoBack()

  const { t } = useTranslation()

  return (
    <div className="fixed mx-auto h-full max-w-2xl overflow-auto p-4">
      <h1 className="mb-4 text-3xl font-bold">{t('Lingo-Cards Privacy Policy')}</h1>
      <p>
        {t(
          'Welcome to Lingo-Cards This Privacy Policy outlines how we collect use and protect your data when you use our services',
        )}
      </p>
      <div className="mt-4">
        {/* eslint-disable-next-line react/jsx-no-literals */}
        <h2 className="mb-2 text-xl font-bold">1. {t('Information We Collect')}</h2>
        <p>{t('Lingo-Cards uses the following information from your Google account')}</p>
        <ul className="list-disc pl-5">
          <li>{t('Email Used for authentication purposes')}</li>
          <li>{t('Given Name and Family Name Concatenated to create a username')}</li>
        </ul>
      </div>
      <div className="mt-4">
        {/* eslint-disable-next-line react/jsx-no-literals */}
        <h2 className="mb-2 text-xl font-bold">2. {t('How We Use Your Information')}</h2>
        <p>{t('We use the collected information to')}</p>
        <ul className="list-disc pl-5">
          <li>{t('Authenticate your identity using your Google email')}</li>
          <li>{t('Create a personalized username for your account')}</li>
          <li>{t('Include the username in email templates for personalized messages')}</li>
        </ul>
      </div>
      <div className="mt-4">
        {/* eslint-disable-next-line react/jsx-no-literals */}
        <h2 className="mb-2 text-xl font-bold">3. {t('Analytics and observability')}</h2>
        <p>{t('Google Analytics body')}</p>
        <p className="mt-2">
          <a
            className="text-blue-500"
            href="https://policies.google.com/privacy"
            rel="noopener noreferrer"
            target="_blank"
          >
            {t('Google Privacy Policy')}
          </a>
          {/* eslint-disable-next-line react/jsx-no-literals */}
          <span>.</span>
        </p>
        <p className="mt-2">{t('Sentry body')}</p>
        <p className="mt-2">
          <a className="text-blue-500" href="https://sentry.io/privacy/" rel="noopener noreferrer" target="_blank">
            {t('Sentry Privacy Policy')}
          </a>
          {/* eslint-disable-next-line react/jsx-no-literals */}
          <span>.</span>
        </p>
      </div>
      <div className="mt-4">
        {/* eslint-disable-next-line react/jsx-no-literals */}
        <h2 className="mb-2 text-xl font-bold">4. {t('Data Security')}</h2>
        <p>
          {t(
            'We take the security of your data seriously We implement measures to protect your information from unauthorized access or disclosure',
          )}
        </p>
      </div>
      <div className="mt-4">
        {/* eslint-disable-next-line react/jsx-no-literals */}
        <h2 className="mb-2 text-xl font-bold">5. {t('Your Choices')}</h2>
        <p>
          {t(
            'You can choose not to provide certain information but this may limit your access to certain features of Lingo-Cards',
          )}
        </p>
      </div>
      <div className="mt-4">
        {/* eslint-disable-next-line react/jsx-no-literals */}
        <h2 className="mb-2 text-xl font-bold">6. {t('Third-Party Access')}</h2>
        <p>
          {t(
            'We use trusted third-party services to operate Lingo-Cards We do not sell your personal data Data is shared only as described in this policy or when required by law',
          )}
        </p>
        <ul className="mt-2 list-disc pl-5">
          <li>
            {t('Third-Party Google Analytics')}{' '}
            <a
              className="text-blue-500"
              href="https://policies.google.com/privacy"
              rel="noopener noreferrer"
              target="_blank"
            >
              {t('Google Privacy Policy')}
            </a>
            {/* eslint-disable-next-line react/jsx-no-literals */}
            <span>.</span>
          </li>
          <li>
            {t('Third-Party Sentry')}{' '}
            <a className="text-blue-500" href="https://sentry.io/privacy/" rel="noopener noreferrer" target="_blank">
              {t('Sentry Privacy Policy')}
            </a>
            {/* eslint-disable-next-line react/jsx-no-literals */}
            <span>.</span>
          </li>
        </ul>
      </div>
      <div className="mt-4">
        {/* eslint-disable-next-line react/jsx-no-literals */}
        <h2 className="mb-2 text-xl font-bold">7. {t('Updates to This Policy')}</h2>
        <p>{t('This Privacy Policy may be updated periodically Please review it occasionally for any changes')}</p>
      </div>
      <div className="mt-4">
        {/* eslint-disable-next-line react/jsx-no-literals */}
        <h2 className="mb-2 text-xl font-bold">8. {t('Contact Us')}</h2>
        <p>
          {t('If you have any questions or concerns about this Privacy Policy please contact us at')}
          {/* eslint-disable-next-line react/jsx-no-literals */}
          <a className="text-blue-500" href="mailto:contact@lingo-cards.app">
            contact@lingo-cards.app
          </a>
          {/* eslint-disable-next-line react/jsx-no-literals */}
          <span>.</span>
        </p>
        <p className="mt-2">{t('Last Updated 25 June 2026')}</p>
      </div>
      <div className="mt-2 flex justify-center gap-2">
        <Button
          className="flex w-36 items-center gap-1"
          onClick={() => (canGoBack ? router.history.back() : router.navigate({ to: '/auth/login' }))}
        >
          {!canGoBack && <ChevronLeftIcon />}
          {canGoBack ? t('Back') : t('To login page')}
        </Button>
      </div>
    </div>
  )
}
